export default "__VITE_ASSET__vFxGVMZK__"